import "./src/App.css";
import "./src/styles/global.css";

export const onClientEntry = () => {
  // Remove the window.onload handler since we're handling it in the component
};
